import { Repeat } from 'lucide-react'
import { FC } from 'react'
import { cn, TooltipWrapper } from '@wellesley/ui'

type TRepostAction = {
  isActiveUndoRepost: boolean
  isFeedAuthor?: boolean
  isDisabledRepost?: boolean
}

const RepostAction: FC<TRepostAction> = ({
  isFeedAuthor,
  isDisabledRepost,
  isActiveUndoRepost,
}) => {
  const tooltipText = isFeedAuthor ? 'Self-reposts aren’t allowed' : ''

  return (
    <TooltipWrapper
      theme="dark"
      size="small"
      tooltipText={tooltipText}
      triggerProps={{
        asChild: true,
      }}
    >
      <div
        className={cn(
          'gap-xxs flex flex-row text-base text-gray-700',
          {
            ['opacity-50']: isDisabledRepost,
          },
          isDisabledRepost ? 'cursor-default' : 'cursor-pointer',
        )}
      >
        <Repeat size={20} color="var(--gray-700)" />
        <span>{isActiveUndoRepost ? 'Undo repost' : 'Repost'}</span>
      </div>
    </TooltipWrapper>
  )
}

export default RepostAction
